// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "2.8.7.customer." + chunkId + "." + {"libs_customer_customer-inventory-v1_src_index_ts":"8f14c844c7526289","libs_customer_customer-documents-v1_src_index_ts":"ec3a0712b00c0756","libs_customer_customer-approvals-v1_src_index_ts":"604e61240d4481a9"}[chunkId] + ".js";
};